import React from 'react'
import { IActionRulesSkipLogicStatementValue } from '@aytm/app/swidget/base/actions/types'
import style from './SkipBlock.module.scss'
import useTheme from '@aytm/app/swidget/base/modules/theme/useTheme'

export interface ISkipBlockProps {
  rules?: IActionRulesSkipLogicStatementValue[]
}

interface ISkipActions {
  length: number
  text: string
  valid: boolean
}

const SkipBlock = React.memo<ISkipBlockProps>(
  ({ rules = [] }) => {
    const skipActions: ISkipActions[] = []
    const theme = useTheme()
    if (!rules.length) return <></>

    rules.forEach(rule => {
      skipActions.push({
        length: rule.target.length,
        text: rule.target
          .map(function (v) {
            return '@exit' === v ? 'Exit' : v.toUpperCase()
          })
          .join(' or '),
        valid: rule.condition
      })
    })
    const icon = skipActions.reduce((a, v) => a + v.length, 0) > 1 ? 'icon-aytmfd-random' : 'icon-aytmfd-skip'

    return (
      <div className={style.skip} style={{ color: theme.style.accentColor }} data-testid="SW-Question-SkipHint">
        <i className={icon}></i>
        {skipActions.map((action, index) => (
          <span key={index} className={`${action.valid ? '' : style.invalid}`}>
            {action.text}
          </span>
        ))}
      </div>
    )
  },
  (prevProps, nextProps) => prevProps.rules === nextProps.rules
)

SkipBlock.displayName = 'SkipBlock'

export default SkipBlock
